import React, { useState } from 'react'
import Logo from '../../paginas/img/logo_fondo_negro.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPowerOff, faBell, faCircleLeft, faLock, faLockOpen, faLeftLong } from '@fortawesome/free-solid-svg-icons'
import { slide as Menu } from 'react-burger-menu'

import {
    MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavItem, MDBNavbarToggler, MDBCollapse, MDBFormInline, MDBHamburgerToggler,
} from "mdbreact";

import { ReactComponent as SearchLogo } from '../../paginas/icons/search.svg';
import { useNavigate } from 'react-router-dom'

const PosMenuMovil = (props) => {
    const navigate = useNavigate()
    const { irAdmin, vistaMovil, cierre, cambiarBuscador, setVistaMovil, cerrarSesion, colorNotificacion, textoNotificacion, Estado, className } = props


    const [state, setState] = useState({ menuOpen: false })

    // This keeps your state in sync with the opening/closing of the menu
    // via the default means, e.g. clicking the X, pressing the ESC key etc.
    const handleStateChange = (state) => {
        setState({ menuOpen: state.isOpen })
    }

    // This can be used to close the menu, e.g. when a user clicks a menu item
    const closeMenu = () => {
        setState({ menuOpen: false })
    }

    // This can be used to toggle the menu, e.g. when using a custom icon
    // Tip: You probably want to hide either/both default icons if using a custom icon
    // See https://github.com/negomi/react-burger-menu#custom-icons
    const toggleMenu = () => {
        setState(state => ({ menuOpen: !state.menuOpen }))
    }


    return (
        <>  <Menu
            isOpen={state.menuOpen}
            onStateChange={(state) => handleStateChange(state)}
            customBurgerIcon={false}
            customCrossIcon={false}
            scaleDown>
            <div className='menu-movil-logo '>
                <img src={Logo} className="logoMenu" />
            </div>
            <div className='menu-movil-item' onClick={irAdmin}>
                <FontAwesomeIcon className='icon-menu' icon={faCircleLeft} color='#834598' size='1x' /> <span>  Volver</span>
            </div>
            <div className='menu-movil-item'>
                {cierre === 'cerrado' ?
                    <>
                        <FontAwesomeIcon className='icon-menu' icon={faLock} color='#cc2900' size='1x' />
                        <span>Caja Cerrada</span>
                    </>
                    : cierre === 'abierto' ?
                        <>
                            <FontAwesomeIcon className='icon-menu' icon={faLockOpen} color='#00cc00' size='1x' />
                            <span>Caja Abierta</span>
                        </>
                        : null}
            </div>
            <div className='menu-movil-item' onClick={cerrarSesion}>
                <FontAwesomeIcon className='icon-menu' icon={faPowerOff} color='#834598' size='1x' /> <span>  Cerrar Sistema</span>
            </div>
            <div className='menu-movil-notificacion' onClick={() => navigate('/Admin', {
                state: {
                    url: 'Inventario',
                }
            })}>
                {textoNotificacion ?
                    <div className={`${colorNotificacion} notificacion`}>
                        <FontAwesomeIcon icon={faBell} /> <span>Inventarios {textoNotificacion}</span>
                    </div>
                    : null}
            </div>
        </Menu>
            <MDBNavbar color="white" expand="md" light className={`${className} menu-pos`}>
                {vistaMovil === 'pedido' ?
                    <MDBNavbarBrand className="search-icons-movil container_atras" onClick={() => setVistaMovil('ver')}>
                        <FontAwesomeIcon className='icon-menu' icon={faLeftLong} color='#834598' size='1xl' />
                    </MDBNavbarBrand>
                    :
                    <MDBNavbarBrand className="search-icons-movil container_atras" onClick={cambiarBuscador}>
                        <SearchLogo fill="#834598" width={25} height={25} />
                    </MDBNavbarBrand>}
                <MDBNavbarBrand>
                    <img src={Logo} className="logoMenu" />
                </MDBNavbarBrand>
                <MDBNavbarToggler image="https://mdbootstrap.com/img/svg/hamburger7.svg?color=834598" onClick={() => toggleMenu()} />
            </MDBNavbar>
        </>)
}

export default PosMenuMovil
